import React from 'react';
import { hydrate, render } from 'react-dom';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const rootElement = document.getElementById('root');

// Use hydrate if the content was pre-rendered by react-snap
if (rootElement.hasChildNodes()) {
  hydrate(
    <HelmetProvider>
      <App />
    </HelmetProvider>,
    rootElement
  );
} else {
  render(
    <HelmetProvider>
      <App />
    </HelmetProvider>,
    rootElement
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
